import "./styles.css";
import { Canvas } from "@react-three/fiber";
import Experience from "./Experience";
import { Suspense } from "react";
import { Loader } from "@react-three/drei";

export default function App() {
  return (
    <Suspense fallback={null}>
      <Canvas
        // flat
        frameloop="demand"
        shadows
        camera={{
          position: [0, 1.5, 5.5],
        }}
      >
        <Experience />
      </Canvas>
      <Loader />
    </Suspense>
  );
}
